import { Directive, ElementRef, Injector, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { FiErrorMessageBase } from '@fi-shared/fi-error-message/fi-error-message-base';
import { NgModel } from '@angular/forms';

@Directive({
    selector: '[fiErrorMessage]',
    standalone: false,
})
export class FiErrorMessageDirective extends FiErrorMessageBase implements OnInit, OnDestroy {
    @Input() fiErrorMessage: NgModel;

    constructor(
        private elementRef: ElementRef<HTMLElement>,
        private renderer: Renderer2,
        injector: Injector,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.renderer.addClass(this.elementRef.nativeElement, 'fi-error-message');
        this.fiErrorMessage.valueChanges.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => this.updateErrorMessage());
        this.fiErrorMessage.statusChanges
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((v) => this.updateErrorMessage());
    }

    private updateErrorMessage() {
        if (this.fiErrorMessage.pending) return;
        const errorMessage = this.getErrorMessage(this.fiErrorMessage);
        this.elementRef.nativeElement.innerText = errorMessage;
    }
}
